<ng-template #utilityBarForm>
  <placement-utility-header [placementData]="placementData" [placementMaintenance]="placementMaintenance"></placement-utility-header>
</ng-template>

<div class="tw:w-full tw:px-4">

  <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-12" [@slider]="panelNumber">

    @if (panelNumber == 1) {
      <div class="tw:w-full tw:p-0 tw:m-0">
        @if (searchPlacementResult?.sessionCalendar && searchPlacementResult.sessionCalendar.length > 0) {
          <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
            <!-- Clickable key: a CTA prompt plus status pills that each toggle a filter on the
                 calendar below. With none selected every session shows; selecting one or more
                 narrows to those statuses. -->
            <div class="tw:w-full tw:mb-8 tw:px-[15px]">
              <div class="tw:text-center tw:mb-3 tw:text-[15px] tw:text-[#555]">
                Filter by status — select a label below to show only those sessions
              </div>
              <div class="tw:flex tw:flex-wrap tw:justify-center tw:items-center tw:gap-2">
                <!-- "All" is the selected state whenever no specific status is chosen: selecting it
                     clears the filter, selecting a status deselects it, and deselecting the last
                     status returns to it. -->
                <button type="button"
                        class="status-filter-pill"
                        [class.status-filter-pill--dimmed]="!isAllStatusesActive()"
                        [attr.aria-pressed]="isAllStatusesActive()"
                        (click)="selectAllStatuses()">
                  <app-session-status-pill status="All"></app-session-status-pill>
                </button>
                @for (status of sessionStatuses; track status) {
                  <button type="button"
                          class="status-filter-pill"
                          [class.status-filter-pill--dimmed]="!isStatusFilterActive(status)"
                          [attr.aria-pressed]="isStatusFilterActive(status)"
                          (click)="toggleStatusFilter(status)">
                    <app-session-status-pill [status]="status"></app-session-status-pill>
                  </button>
                }
              </div>
            </div>
            <!-- tw:relative: the calendar's :host is position:absolute; without a positioned
                 ancestor it anchors to the fixed-height page shell and never scrolls with
                 the page. -->
            <div class="tw:w-full tw:px-[15px] tw:pb-12 tw:relative" #sessionContainer>
              <session-overview-session-calendar
                [sessionCalendar]="searchPlacementResult.sessionCalendar"
                [sessionContainer]="sessionContainer"
                [isExternal]="true"
                [showNavButtons]="true"
                [wrapOnMonth]="true"
                [wrapWeeks]="true"
                [statusFilter]="activeStatuses"
                (sessionSelected)="sessionSelected($event)" #sessionCalendar>
              </session-overview-session-calendar>
            </div>
          </div>
        } @else {
          No sessions found
        }
      </div>
    }
    
    @if (panelNumber == 2) {
      @if (lessonType === 'LearnerJourney') {
        <div class="tw:flex-1 tw:px-[15px]">
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-2">
            <div class="tw:w-full tw:px-[15px]">
              <div class="tile-padding-first">
                <div class="app-nav-back-btn tw:mx-1 tw:float-left" (click)="showCalendarView()">Back to calendar</div>
              </div>
            </div>
          </div>
          <div class="tw:flex tw:flex-wrap tw:m-0 tw:p-0">
            <div class="tw:flex-1 tw:m-0 tw:p-0">
              <student-bookings
                [placementId]="placementId"
                [selectedSessionDate]="selectedSessionInfo"
                [componentViewMode]="'View'"
                [subject]="subject"
                (onDataChanged)="sessionDeleted($event)">
              </student-bookings>
            </div>
          </div>
        </div>
      }
      @if (lessonType === 'LeapV2') {
        <div class="tw:flex-1 tw:px-[15px]">
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-2">
            <div class="tw:w-full tw:px-[15px]">
              <div class="tile-padding-first">
                <div class="app-nav-back-btn tw:mx-1 tw:float-left" (click)="showCalendarView()">Back to calendar</div>
              </div>
            </div>
          </div>
          <div class="tw:flex tw:flex-wrap tw:m-0 tw:p-0">
            <div class="tw:flex-1 tw:m-0 tw:p-0">
              <tutor-report-leap-v2 #report></tutor-report-leap-v2>
            </div>
          </div>
        </div>
      }
    }
  </div>

</div>
